import GuideCollectionConverter from 'scripts/application/dto_converters/guide_collection_converter';
import { handleCommonErrors } from 'scripts/application/lib/gateway_error_interactive_handler';

export default function fetchGuideCollections(context) {
  const { guideCollections, organization: organizationStore } = context.stores;
  const { guideCollection } = context.gateways;

  const organization = organizationStore.get();
  if (!organization.isSidekickEnabled || !context.stores.appFeatures.get().isEnabled('viewGuidePerformance')) {
    return;
  }

  guideCollections.setLoading();

  return guideCollection
    .fetchAll()
    .then(responseDto => {
      const collections = responseDto ? responseDto.map(GuideCollectionConverter.fromDto) : [];
      guideCollections.set(collections);
      return collections;
    })
    .catch(err => {
      handleCommonErrors(context, err);
    })
    .finally(() => guideCollections.resetLoading());
}
